import type { IconComponent } from "./types";

export const AddCalendar: IconComponent = ({ ref, color = "currentColor", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" ref={ref} {...props}>
      <title>Add Calendar</title>
      <path
        fill={color}
        d="M15.82 15.82V6.68H4.18v9.14h11.64Zm-2.5-15H15V2.5h.82c.47 0 .86.17 1.17.5.34.32.51.71.51 1.18v11.64c0 .47-.17.87-.5 1.21-.32.31-.71.47-1.18.47H4.18c-.47 0-.87-.16-1.21-.47a1.72 1.72 0 0 1-.47-1.21V4.18c0-.47.16-.86.47-1.17.34-.34.74-.51 1.21-.51H5V.82h1.68V2.5h6.64V.82ZM9.18 7.93h1.64v2.5h2.5v1.64h-2.5v2.5H9.18v-2.5h-2.5v-1.64h2.5v-2.5Z"
      />
    </svg>
  );
};
AddCalendar.displayName = "AddCalendar";
